import {DEPOTS_AT_AREA_KEY, OUTOFBOUNDS_DEPOTS_KEY} from '../Constants/StorageKeys';
import {IBaseSearchParam} from '../Types/ISearchParam';
import {IDepotInfo} from '../Types/IDepot';
import {fetchDepots} from '../API/DepotApi';
import Environment from '../Enum/Environment';
import {DEFAULT_SEARCH_RADIUS} from '../Constants/SearchRadius';
import {removeDepotInfoDuplicate} from '../Utils/ResultsUtils';

export const getOutOfBoundsDepots = (env: Environment, searchParams: IBaseSearchParam): Promise<IDepotInfo[]> => {
    return new Promise<IDepotInfo[]>((resolve): void => {
        try {
            const cachedDepots: IDepotInfo[] | null = getDepotsFromCache(searchParams);
            if (cachedDepots !== null) {
                resolve(cachedDepots);
            } else {
                fetchDepots(env, searchParams)
                    .then((result) => {
                        saveDepotsToCache(result, searchParams);
                        resolve(result)
                    })
                    .catch(() => {
                        resolve([]);
                    })
            }
        } catch {
            resolve([]);
        }
    })
}

export const getDepotsAtTheArea = (env: Environment, searchParams: IBaseSearchParam): Promise<IDepotInfo[]> => {
    return new Promise<IDepotInfo[]>((resolve): void => {
        try {
            const cachedDepots: IDepotInfo[] | null = getDepotsFromCache(searchParams, false);
            if (cachedDepots !== null) {
                resolve(cachedDepots);
            } else {
                fetchDepots(env, searchParams, {
                    minRadius: 0,
                    maxRadius: DEFAULT_SEARCH_RADIUS
                })
                    .then((result) => {
                        saveDepotsToCache(result, searchParams, false);
                        resolve(result)
                    })
                    .catch(() => {
                        resolve([]);
                    })
            }
        } catch {
            resolve([]);
        }
    })
}

const formatSearchParamToStorageKey = (searchParam: IBaseSearchParam, isOutOfBound: boolean = true): string => {
    return `${isOutOfBound ? OUTOFBOUNDS_DEPOTS_KEY : DEPOTS_AT_AREA_KEY}_${searchParam.date}_${searchParam.latitude}_${searchParam.longitude}`
}

const saveDepotsToCache = (result: IDepotInfo[], searchParam: IBaseSearchParam, isOutOfBound: boolean = true): void => {
   try {
       localStorage.setItem(`${formatSearchParamToStorageKey(searchParam, isOutOfBound)}`, JSON.stringify(result));
   } catch {}
}

const getDepotsFromCache = (searchParam: IBaseSearchParam, isOutOfBound: boolean = true): IDepotInfo[] | null => {
    const result: string | null = localStorage.getItem(`${formatSearchParamToStorageKey(searchParam, isOutOfBound)}`);

    if (result === null) {
        return result;
    }

    try {
        const depots = JSON.parse(result) as IDepotInfo[];
        return removeDepotInfoDuplicate(depots);
    } catch {
        return null;
    }
}
